var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWarningCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71875 10C1.71875 5.44365 5.4124 1.75 9.96875 1.75C14.5251 1.75 18.2188 5.44365 18.2188 10C18.2188 14.5563 14.5251 18.25 9.96875 18.25C5.4124 18.25 1.71875 14.5563 1.71875 10ZM9.96875 0.25C4.58397 0.25 0.21875 4.61522 0.21875 10C0.21875 15.3848 4.58397 19.75 9.96875 19.75C15.3535 19.75 19.7188 15.3848 19.7188 10C19.7188 4.61522 15.3535 0.25 9.96875 0.25ZM10.7188 7C10.7188 6.58579 10.383 6.25 9.96875 6.25C9.55454 6.25 9.21875 6.58579 9.21875 7V10.75C9.21875 11.1642 9.55454 11.5 9.96875 11.5C10.383 11.5 10.7188 11.1642 10.7188 10.75V7ZM9.96875 13C9.55454 13 9.21875 13.3358 9.21875 13.75V13.7575C9.21875 14.1717 9.55454 14.5075 9.96875 14.5075H9.97625C10.3905 14.5075 10.7262 14.1717 10.7262 13.7575V13.75C10.7262 13.3358 10.3905 13 9.97625 13H9.96875Z",
    fill: "#CCA319"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningCircle);
export default __webpack_public_path__ + "static/media/icon-warning-circle.295f31e79f1934c9550a64831c65290b.svg";
export { ForwardRef as ReactComponent };